import type { LanguageQualificationFormData } from '../../../graphql';
import {
  type FormController,
  FormModificationMode,
} from '../../../../../utils';
import {} from '../../../graphql';

export type LanguageQualificationControl = Record<
  keyof LanguageQualificationFormData,
  boolean
> & {
  enableSave: boolean;
  enableSaveCondition: boolean;
};

export type LanguageFormFieldPermissions = Omit<
  LanguageQualificationControl,
  'languageQualificationId'
>;

// Only records with "I will update result at xxx" can be updated.
// Fields allowed for update: date of result receipt, and results.
// New documents can be added.
export const editLanguagePermission = (
  values: LanguageQualificationFormData,
  control: FormController,
): LanguageFormFieldPermissions => {
  const { formModificationMode } = control;
  const { resultAnnouncedIndicator } = values;

  // Language qualification form field permissions
  const disableLanguageFieldPermissions: LanguageFormFieldPermissions = {
    needEnglishTest: false,
    testType: false,
    testDate: false,
    resultAnnouncedIndicator: false,
    expectedResultUpdateDate: false,
    listening: false,
    writing: false,
    speaking: false,
    reading: false,
    overall: false,
    referenceNo: false,
    resultReceiptDate: false,
    supportingDocuments: false,
    enableSave: false,
    enableSaveCondition: false,
  };

  const enableLanguageFieldPermissions: LanguageFormFieldPermissions = {
    ...Object.assign(
      {},
      ...Object.keys(disableLanguageFieldPermissions).map(key => ({
        [key]: true,
      })),
    ),
    enableSaveCondition:
      formModificationMode === FormModificationMode.CONDITION_MEET,
  };

  const modifyLanguageFieldPermissions: LanguageFormFieldPermissions = {
    ...disableLanguageFieldPermissions,
    ...(resultAnnouncedIndicator === false && {
      testType: true,
      testDate: true,
      resultAnnouncedIndicator: true,
      expectedResultUpdateDate: true,
      listening: true,
      writing: true,
      speaking: true,
      reading: true,
      overall: true,
      referenceNo: true,
      supportingDocuments: true,
      enableSave: true,
    }),
  };

  const languagePermission: Record<
    FormModificationMode,
    LanguageFormFieldPermissions
  > = {
    [FormModificationMode.ENABLE]: enableLanguageFieldPermissions,
    [FormModificationMode.DISABLE]: disableLanguageFieldPermissions,
    [FormModificationMode.MODIFIED_ONLY]: modifyLanguageFieldPermissions,
    [FormModificationMode.CONDITION_MEET]: enableLanguageFieldPermissions,
  };
  return languagePermission[formModificationMode];
};
